import { Component } from "react";
import dayjs from "@shared/dayjs";
import Task from "./Task"; //need to implement this using code from PolymorphicTask
import axios from "axios";
import SelectAll from "../../../shared/SelectAll";
import Pagination from "../../../shared/Pagination";
import * as TaskHelpers from "../TaskIndexModalHelpers";
import * as button from "../../../PersonDetail/components/button.module.css";
import * as tasks from "../../../PersonDetail/components/tasks/tasks.module.css";

export default class Grid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: props.user,
      tasks: [],
      taskable: props.taskable,
      account: props.account,
      pagination: {},
      page: props.page || 1,
      showButtons: false,
      selectNone: false,
      selectAll: false,
      header_buttons: false,
      incomplete_buttons: false,
      showDeleteModal: false,
      assigned_to_user_id: "anyone",
      reschedule_date: dayjs().format("YYYY-MM-DD"),
    };

    this.multiSelectWatcher = TaskHelpers.multiSelectWatcher.bind(this);
    this.selectAll = TaskHelpers.selectAll.bind(this);
    this.selectNone = TaskHelpers.selectNone.bind(this);
    this.taskMultiSelect = TaskHelpers.taskMultiSelect.bind(this);
    this.handleTaskChange = TaskHelpers.handleTaskChange.bind(this);
    this.handleState = TaskHelpers.handleState.bind(this);
    this.handleRescheduleDate = TaskHelpers.handleRescheduleDate.bind(this);

    this.selectedTasks = TaskHelpers.selectedTasks.bind(this);
    this.setAgentsForModal = TaskHelpers.setAgentsForModal.bind(this);

    this.uncompleteTasks = TaskHelpers.uncompleteTasks.bind(this);
    this.uncompleteTask = TaskHelpers.uncompleteTask.bind(this);

    this.completeTasks = TaskHelpers.completeTasks.bind(this);
    this.completeTask = TaskHelpers.completeTask.bind(this);

    this.rescheduleTasks = TaskHelpers.rescheduleTasks.bind(this);
    this.rescheduleTask = TaskHelpers.rescheduleTask.bind(this);

    this.updateTask = TaskHelpers.updateTask.bind(this);
    this.handleGotoPage = this.handleGotoPage.bind(this);
  }

  getTasks = () => {
    let { page } = this.state;
    axios({
      method: "get",
      url: `/tasks/taskable_index?id=${this.props.taskable.uuid}&scopes=${this.props.scopes}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {
        page: page,
      },
    }).then((response) => {
      let { meta, tasks } = response.data;
      this.setState({ ...this.state, ...{ tasks: tasks, pagination: meta } });
    });
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.multiSelectWatcher();
  };

  showErrors = (messages) => {
    this.setState({ error_messages: messages });
  };

  componentDidMount() {
    this.getTasks();
    const TASK_LISTENER = "task:polymorphic_count_change";
    window.addEventListener(TASK_LISTENER, this.onEvent);
    window.addEventListener("task:update", this.onEvent);
  }

  componentWillUnmount() {
    const TASK_LISTENER = "task:polymorphic_count_change";
    window.removeEventListener(TASK_LISTENER, this.onEvent);
    window.removeEventListener("task:update", this.onEvent);
  }

  onEvent = () => {
    this.getTasks();
  };

  showErrors = (messages) => {
    this.setState({ error_messages: messages });
  };

  filteredTasks = () => {
    return {
      incomplete: this.state.tasks,
      completed: this.state.tasks,
      contingent: this.state.tasks,
    };
  };

  handleGotoPage(newPage) {
    this.setState({ page: newPage }, this.getTasks);
  }

  showReassignModal = () => {
    this.props.showReassignModal({
      selectedTasks: this.selectedTasks(),
      assignedToUserId: this.state.assigned_to_user_id,
      agentsOptions: this.setAgentsForModal(),
      form: this.state,
    });
  };

  showRescheduleModal = () => {
    this.props.showRescheduleModal({
      selectedTasks: this.selectedTasks(),
    });
  };

  showDeleteModal = (task) => {
    this.props.showDeleteModal({
      selectedTasks: task ? [task] : this.selectedTasks(),
    });
  };

  render() {
    let { pagination } = this.state;
    return (
      <div>
        <div
          className={"last-row " + `${this.props.dueness}-complete-tasks-grid`}
          data-page={this.props.completeTasksPage || 1}
        >
          <div>
            <div className={`${tasks.taskHeader} tw-flex tw-uppercase`}>
              <div className="tw-basis-5/12">
                <h6>{this.props.duenessTitle}</h6>
              </div>
              <div className="tw-basis-1/12 text-center">
                <h6>Date</h6>
              </div>
              <div className="tw-basis-1/12 text-center">
                <h6>
                  {this.props.agent && "Priority"}
                  {!this.props.agent && "\u00A0"}
                </h6>
              </div>
              <div className="tw-basis-1/12 text-center">
                <h6>Who</h6>
              </div>
              <div className="tw-basis-2/12 text-center">
                <h6>
                  {this.props.agent && "Settings"}
                  {!this.props.agent && "\u00A0"}
                </h6>
              </div>
              {this.props.agent && (
                <div className="tw-basis-1/12">
                  <h6>Edit</h6>
                </div>
              )}
              {!this.props.agent && (
                <div className="tw-basis-1/12">
                  <h6>{"\u00A0"}</h6>
                </div>
              )}
              {this.props.agent && (
                <div className="tw-basis-1/12 text-center">
                  <SelectAll
                    selectAllHandler={this.selectAll}
                    selectAll={this.state.selectAll}
                    selectNone={this.state.selectNone}
                    selectNoneHandler={this.selectNone}
                  />
                </div>
              )}
              {!this.props.agent && <div className="tw-basis-1/12" />}
            </div>
            {this.state.header_buttons && (
              <div className="tw-flex tw-justify-end tw-gap-[8px] tw-p-[4px]">
                {this.props.multiSelectButtons && (
                  <>
                    <a
                      onClick={this.completeTasks}
                      className={`${button.btn} ${button.btnLg} ${button.btnDarkBlue} complete`}
                    >
                      <span>
                        <i className={"fa fa-clock-o"} />
                        Complete
                      </span>
                    </a>
                    <a
                      onClick={() => this.showDeleteModal(this.props.task)}
                      className={`${button.btn} ${button.btnLg} ${button.btnDanger} delete`}
                    >
                      <span>
                        <i className={"fa fa-times"} />
                        Delete
                      </span>
                    </a>
                    <a
                      onClick={this.showRescheduleModal}
                      className={`${button.btn} ${button.btnLg} ${button.btnBlue} reschedule`}
                    >
                      <span>
                        <i className={"fa fa-clock-o"} />
                        Reschedule
                      </span>
                    </a>
                    <a
                      onClick={this.showReassignModal}
                      className={`${button.btn} ${button.btnLg} ${button.btnYellow} reassign`}
                    >
                      <span>
                        <i className={"fa fa-users"} />
                        Reassign
                      </span>
                    </a>
                  </>
                )}
                {this.props.uncomplete && (
                  <button
                    onClick={this.uncompleteTasks}
                    className={"btn btn-success-inverse btn-sm uncomplete"}
                  >
                    <span>
                      <i className={"fa fa-square-o"} />
                      Un-complete
                    </span>
                  </button>
                )}
              </div>
            )}
            <div className={"clearfix"} />
            <div className={"completed-tasks content"} />
          </div>
        </div>
        <div className={`!tw-ml-0 ${this.props.dueness}`}>
          {this.state.tasks &&
            this.filteredTasks()[this.props.dueness].map((task) => (
              <Task
                dueness={this.props.dueness}
                agent={this.props.agent}
                getTasks={this.getTasks}
                key={task.id}
                task={task}
                multiSelectWatcher={this.multiSelectWatcher}
                editTask={this.props.editTask}
                showDeleteModal={this.showDeleteModal}
                showTaskDetails={this.props.showTaskDetails}
              />
            ))}
        </div>
        {pagination.total_count > 35 && pagination && (
          <div className="row">
            <div className="col-xs-6 col-xs-offset-3">
              <Pagination
                currentPage={pagination.current_page}
                nextPage={pagination.next_page}
                prevPage={pagination.prev_page}
                totalPages={pagination.total_pages}
                totalCount={pagination.total_count}
                onGoToPage={this.handleGotoPage}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
